import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActionData } from '../../data-rules-model';
import { DataRulesService } from '../../data-rules.service';
import { ActionDullInputComponent } from '../action-dull-input/action-dull-input.component';
import { IrreversibleActionWarningBlockComponent } from '../action-warning-block/irreversible-action-warning-block.component';

@Component({
  selector: 'app-hard-delete',
  templateUrl: './hard-delete.component.html',
  imports: [
    ActionDullInputComponent,
    IrreversibleActionWarningBlockComponent
  ],
  styleUrls: ['../action.component.scss']
})
export class HardDeleteComponent implements OnInit {
  @Input() primaryEntity: string;
  @Input() actionData: ActionData;
  @Input() actionForm: FormGroup;

  warningMessage = 'Using hard delete on Placement Commissions is irreversible and will not produce sample output. Are you sure you want to proceed?';
  actionDescription: string;

  constructor(public dataRulesService: DataRulesService) {
  }

  ngOnInit () {
    this.actionDescription = `Will delete ${this.primaryEntity} entity`;
    this.createControls();
  }

  createControls(): void {
    this.actionForm.removeControl('type');

    this.actionForm.addControl('type', new FormControl(this.actionData.type));
  }

  get actionType(): string {
    return this.dataRulesService.actionOpName(this.dataRulesService.actionOperators.DELETE);
  }

}
